import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { KeycloakService } from 'keycloak-angular';
import { CookieService } from 'ngx-cookie-service';
import { async, map, tap } from 'rxjs';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { config } from 'src/app/config/api.config';
import { PlateformeLMSService } from 'src/app/modules/plateforme-lms/services/plateforme-lms.service';
import { ProgrammeCoursera } from 'src/app/model/programme-coursera';

import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { environment } from 'src/environments/environments';
import { ProfilDetails } from 'src/app/model/profilDetails';
import { AppelsService } from 'src/app/modules/appels/service/appels.service';

@Component({
  selector: 'app-side-bar-admin',
  templateUrl: './side-bar-admin.component.html',
  styleUrls: ['./side-bar-admin.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarAdminComponent {
  constructor(
    private router: Router,
    private appelservice: AppelsService,
  ) { }
  user: any | null;
  profil: any;
  logged: any;
  role!: any;
  cohorte!: string;
  nomrole!: string;
  isAdmin: boolean = false;
  isAdminAipen: boolean = false;
  isAdminCom: boolean = false;
  isAdminSuivi: boolean = false;
  isAdminFinance: boolean = false;
  isAdminFcc: boolean = false;
  courseraCohorts: any[] = [];
  urlScholarVox = 'https://skills.scholarvox.com/forcen';
  urlFondAmorcage: string = 'https://fa.force-n.sn/auth/login/keycloak';

  urlClasseVirtuelle: string =
    'https://formation.force-n.sn/mod/bigbluebuttonbn/view.php?id=43470';

  sections = [
    { id: 1, isCollapsed: true },
    { id: 2, isCollapsed: true },
    { id: 3, isCollapsed: true },
    { id: 4, isCollapsed: true },
    { id: 5, isCollapsed: true },
  ];
  listFamily: any;
  listofftrack: any;
  showIframe = false;
  ngOnInit() {
    this.getFamily();
    this.getOfftrack();
    this.getCourseraCohortes();
    this.user = sessionStorage.getItem('user');
    // console.log('user side bar admin :',this.user)
    this.logged = sessionStorage.getItem('logged');
    this.profil = JSON.parse(this.user).profile.id;

    this.role = JSON.parse(this.user)?.roles;
    //console.log(this.role);
    this.cohorte = JSON.parse(
      this.user,
    ).beneficiaryCohortes[0]?.cohorte.cohorteName;
    if (this.role.length > 0) {
      this.role.forEach((element: { id: number; roleName: any }) => {
        this.nomrole = element.roleName;
        sessionStorage.setItem('nomrole', this.nomrole);
        switch (element.roleName) {
          case 'admin': {
            this.isAdmin = true; //Administrateur
            break;
          }
          case 'admin-fcc': {
            this.isAdminFcc = true; //Administrateur FCC
            break;
          }

          case 'admin-aipen': {
            this.isAdminAipen = true; //Administrateur Aipen
            break;
          }

          case 'admin-com': {
            this.isAdminCom = true; //Administrateur Com
            break;
          }
          case 'admin-suivi': {
            this.isAdminSuivi = true; //Administrateur Suivi
            break;
          }
          case 'admin-finance': {
            this.isAdminFinance = true; //Administrateur Finance
            break;
          }
        }
      });
      // console.log(
      //   "le profil de l'apprenant xxxxxx : ",
      //   this.profil
      // );
    }
    // console.log('user role: ', this.user);
  }
  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    //skipLocationChange:true means dont update the url to / when navigating
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        // console.log(`After navigation I am on:${this.router.url}`);
      });
    });
  }
  sessionChange(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidatures/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidatures/' + cohorte);
    }, 500);
  }

  sessionChangeHparcours(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidaturesHS/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidaturesHS/' + cohorte);
    }, 500);
  }

  toggleCollapse(id: number): void {
    const section = this.sections.find((sec) => sec.id === id);
    if (section) {
      section.isCollapsed = !section.isCollapsed;
    }
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }
  getFamily() {
    this.appelservice.getFamiliesWithCohortes().subscribe({
      next: (data: any[]) => {
        this.listFamily = data.map((family) => ({
          ...family,
          isCollapsed: true,
        }));
      },
      error: (error) => {
        console.error(error);
        alert("Une erreur s'est produite lors de la récupération des données");
      },
    });
  }
getOfftrack() {
  this.appelservice.getOffTractWithCohortes().subscribe({
    next: (data: any[]) => {
      this.listofftrack = this.groupByCountry(data);
    },
    error: (error) => {
      console.error(error);
      alert("Une erreur s'est produite lors de la récupération des données");
    },
  });
}

  // true si le nom de la cohorte contient "benin" (insensible à la casse et aux accents)
private isBenin(cohorteName: string): boolean {
  return (cohorteName ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .includes('BENIN');
}

// "MAE" dans le nom => Module acculturation
private isMae(name: string): boolean {
  return (name ?? '').toUpperCase().includes('MAE');
}

// HSIG25... => 2025 (les 2 chiffres après HSIG)
private extractYear(name: string): string {
  const m = /HSIG(\d{2})/i.exec(name ?? '') ?? /(\d{2})/.exec(name ?? '');
  return m ? '20' + m[1] : 'Autres';
}


// Extrait la date yyMM du nom (HSIG2511-FODE => 2511). Retourne 0 si introuvable.
private extractYearMonth(name: string): number {
  const m = /HSIG\D*(\d{2})(\d{2})/i.exec(name ?? '') ?? /(\d{2})(\d{2})/.exec(name ?? '');
  return m ? parseInt(m[1] + m[2], 10) : 0;
}

// Préfixe sans la date : "HSIG2511-FODE" => "HSIG-FODE", "HSIGBENIN2511-FODE" => "HSIGBENIN-FODE"
private extractPrefix(name: string): string {
  return (name ?? '').replace(/\d{4}/, '').trim();
}

// Tri naturel : HSIG2510 avant HSIG259, insensible à la casse
// Tri : ordre alphabétique (préfixe), puis date (la plus récente d'abord)
private sortCohortes(names: string[]): string[] {
  return [...names].sort((a, b) => {
    const alpha = this.extractPrefix(a).localeCompare(
      this.extractPrefix(b),
      'fr',
      { numeric: true, sensitivity: 'base' },
    );
    return alpha !== 0
      ? alpha
      : this.extractYearMonth(b) - this.extractYearMonth(a);
  });
}

// Pays > Catégorie (Module acculturation / E business) > Cohortes
// Pays > Année > Catégorie > Cohortes
private groupByCountry(groups: any[]) {
  // on met à plat toutes les cohortes, sans doublon
  const allNames: string[] = Array.from(
    new Set(groups.flatMap((g) => g.cohorteNames ?? [])),
  );

  const countries = [
    { name: 'Sénégal', benin: false },
    { name: 'Bénin', benin: true },
  ];

  return countries.map((country) => {
    const cohortes = allNames.filter((n) => this.isBenin(n) === country.benin);

    const years = Array.from(new Set(cohortes.map((n) => this.extractYear(n))))
      .sort((a, b) => {
        if (a === 'Autres') return 1;   // "Autres" à la fin
        if (b === 'Autres') return -1;
        return b.localeCompare(a);      // années récentes d'abord
      });

    return {
      name: country.name,
      isCollapsed: true,
      years: years.map((year) => {
        const ofYear = cohortes.filter((n) => this.extractYear(n) === year);
        const categories = [
          {
            name: 'Module acculturation',
            cohorteNames: this.sortCohortes(ofYear.filter((n) => this.isMae(n))),
          },
          {
            name: 'E business',
            cohorteNames:  this.sortCohortes(ofYear.filter((n) => !this.isMae(n))),
          },
        ]
          .filter((c) => c.cohorteNames.length > 0)
          .map((c) => ({ ...c, isCollapsed: true }));

        return { name: year, isCollapsed: true, categories };
      }),
    };
  });
}
  toggleOfftrack(offtrack: any) {
    offtrack.isCollapsed = !offtrack.isCollapsed;
  }

  getCourseraCohortes() {
    this.appelservice
      .getCourseraCohortes()
      .pipe(
        tap((cohortes) => {
          console.log('liste cohortes: ', cohortes);
          this.courseraCohorts = cohortes;
        }),
      )
      .subscribe();
  }
}
